import { useMemo } from 'react';
import styles from './styles.module.scss';
import { ICON_VARIANT_TYPE, Icons } from 'pages/FormProcess/Icons';
import { Close, Dots } from 'components/Icons';
import { useSelector } from 'react-redux';
import { getDynamicFormSelector } from 'store/selectors/requestFormProcess';
import classNames from 'classnames';
import { InfoTooltip } from 'pages/FormProcess/DynamicForm/Containers/DynamicEditor/components/InfoTooltip';
import { useScreen } from 'hooks';

export const PreviewDetailSection = (props) => {
  const { isCompleted, isDeclined, isCanceled, isCompleteOrCanceledOrDeclined } = props;

  const { meta: { documentName, address } = {} } = useSelector(getDynamicFormSelector);
  const { isMobile } = useScreen();

  const status = useMemo(() => {
    if (isCompleted) return 'Complete';
    if (isDeclined) return 'Declined';
    if (isCanceled) return 'Voided';
  }, [isCompleteOrCanceledOrDeclined]);

  return (
    <div className={styles.formDetailSection}>
      <Icons variant={'FileBundle'} />

      <div className={styles.formInformation}>
        <div className={styles.documentName}>{documentName}</div>

        {(status || address) && (
          <div className={classNames(styles.subTitleInfo)}>
            {address && (
              <span
                className={classNames(styles.addressInfo, {
                  [styles.addressWithStatus]: address && status,
                })}
              >
                {isMobile ? <InfoTooltip text={address}>{address}</InfoTooltip> : address}
              </span>
            )}
            {address && status ? <span className={styles.dot} /> : ''}

            {status && (
              <span
                className={classNames({
                  [styles.statusText]: isCompleteOrCanceledOrDeclined,
                  [styles.completed]: isCompleted,
                  [styles.declinedOrCancelled]: isDeclined || isCanceled,
                })}
              >
                {status}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
